import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import Archive2022 from 'views/CyberClub/components/Archive2022';
import Sidebar2024 from '../LibraryManagement2023/component/Sidebar2024';
import CyberAssociationsidebar from '../CyberAssociationsidebar';


const SeniorCyberAssociation2025 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });

    const [config, setConfig] = useState({ base_image_archive_url_2025: '' });
    useEffect(() => {
        fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
            .then(response => response.json())
            .then(data => setConfig(data))
            .catch(error => console.error('Error fetching config:', error));
    }, []);

    const p1 = `${config.base_image_url_2025}/home/events-activities/association/Cyber/Senior/1.webp`;
    const p2 = `${config.base_image_url_2025}/home/events-activities/association/Cyber/Senior/2.webp`;
    const p3 = `${config.base_image_url_2025}/home/events-activities/association/Cyber/Senior/3.webp`;
    const p4 = `${config.base_image_url_2025}/home/events-activities/association/Cyber/Senior/4.webp`;
    const p5 = `${config.base_image_url_2025}/home/events-activities/association/Cyber/Senior/5.webp`;
    const p6 = `${config.base_image_url_2025}/home/events-activities/association/Cyber/Senior/6.webp`;
   

    const photos = [
        {
    src: p1,
    source: p1,
    rows: 1,
    cols: 1,
},
{
    src: p2,
    source: p2,
    rows: 1,
    cols: 1,
},
{
    src: p3,
    source: p3,
    rows: 1,
    cols: 1,
},
{
    src: p4,
    source: p4,
    rows: 1,
    cols: 1,
},
{
    src: p5,
    source: p5,
    rows: 1,
    cols: 1,
},
{
    src: p6,
    source: p6,
    rows: 1,
    cols: 1,
}


    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                <Typography variant='h4' align='center'>
                                    Webfinity – Website Making
                                </Typography>
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                                    Class: 9 to 12  Date: 10 October 2025
                                </Typography>

                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
                                   The Senior Cyber Association successfully conducted the inter-house event “Webfinity – Website Making” on 7 October 2025, with the aim of fostering awareness and skills in web development among students. The competition was structured in two phases to ensure a comprehensive evaluation of both technical knowledge and practical application. 
                                    <br></br>
                                    Finalists participated in a website development contest and were evaluated on elements such as audience relevance, aesthetic design, content effectiveness, delivery, etc. Students showed great enthusiasm and demonstrated innovation, technical ability, teamwork, critical thinking and other key skills that influenced the outcome.  
                                    <br></br>
                                    ‘Webfinity’ proved to be a valuable platform for students to explore and enhance their web development skills, while also learning the importance of design thinking and user-centric content. The event concluded on a high note, with all participants gaining insightful feedback and encouragement to continue their journey in technology.
                                    <br></br>

                                </Typography>
                            </Box>
                            <Typography
                                variant={'h5'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                "BEHIND EVERY SUCCESSFUL DIGITAL CREATION IS A THOUGHTFUL BALANCE BETWEEN CREATIVITY AND FUNCTIONALITY—WHERE AESTHETICS INSPIRE AND USABILITY EMPOWERS, CREATING SOMETHING THAT TRULY RESONATES."
                                <br />
                            </Typography>

                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 300 : 200}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>

                        <Box marginBottom={4}>
                            <CyberAssociationsidebar/>
                        </Box>

                        <Box marginBottom={4}>
                            <Archive2022 />
                        </Box>

                        {/* <SidebarNewsletter /> */}
                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default SeniorCyberAssociation2025;